import type { DatasetOperationV20260601 } from '@cotera/api';

/**
 * The column types a dataset column can be declared as — the same set the
 * `add_column` operation accepts, so the picker cannot offer something the
 * artifact writer would reject.
 */
export type DatasetOperationColumnType = Extract<
  DatasetOperationV20260601,
  { type: 'add_column' }
>['columnType'];

export const DATASET_COLUMN_TYPE_OPTIONS: {
  value: DatasetOperationColumnType;
  label: string;
}[] = [
  { value: 'string', label: 'Text' },
  { value: 'number', label: 'Number' },
  { value: 'boolean', label: 'Boolean' },
  { value: 'date', label: 'Date' },
];
